import { useMemo } from 'react'
import { useAsync } from 'react-use'

import { useAccountContext } from 'components/contexts/AccountContext'
import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'
import { fetchPartnerLicenses } from 'utils'
import useCustomerAccounts from './useCustomerAccounts'
import useHasPartnerAccess from './useHasPartnerAccess'

const usePartnerFeatures = () => {
  const { accountKey: selectedAccountKey, partnerAccountKey } = useAccountContext()
  const { loading: customersLoading, customerAccounts } = useCustomerAccounts()
  const { hasPartnerAccess } = useHasPartnerAccess()
  const iAm = useConnectedUserContext()

  const selectedAccount = iAm?.accounts?.find((account) => account.key === selectedAccountKey)

  const { value: licenses, loading: licensesLoading } = useAsync(async () => {
    const accountKey = (selectedAccount?.partner && selectedAccountKey) || (hasPartnerAccess && partnerAccountKey)
    return accountKey ? fetchPartnerLicenses(accountKey) : null
  }, [partnerAccountKey, selectedAccountKey])

  const isIngramAccount = useMemo(
    () => Array.isArray(licenses) && !!licenses.some((license) => license.channel === 'ingram'),
    [licenses],
  )
  const hasGoToResolve = useMemo(
    () =>
      !customersLoading &&
      Array.isArray(customerAccounts) &&
      customerAccounts.some((customer) =>
        customer.licenses.some((license) => license.roles?.includes('ROLE_GOTORESOLVE_ORGANIZER')),
      ),
    [customersLoading, customerAccounts],
  )

  return { loading: licensesLoading || customersLoading, hasGoToResolve, isIngramAccount }
}

export default usePartnerFeatures
